import { parseUnits } from "viem";

/**
 * Parse a value from a string to a BigInt e.g. "1.8" -> BigInt.from(1800000000000000000)
 * @param value
 * @param decimals
 * @returns BigInt
 */
export const toDecimals = (value: string, decimals = 18) => parseUnits(value, decimals);
